import BaseModel from '../../base';

export default class EventRecommendation extends BaseModel {
  constructor(item, url) {
    super(item, url);

    this.short_name = item.short_name;
    this.announcement = item.announcement;
    this.target = item.target;
    this.start_at = item.start_at;
    this.end_at = item.end_at;
    this.score = item.score;
    this.confidence = item.confidence;

    this.factors = item.factors || null;
  }
}
